import { FaLinkedin, FaGithub } from 'react-icons/fa';
import * as React from 'react';
export default {
  FaLinkedin,
  FaGithub,
  React
};